import React, { Component } from 'react';
import {Helmet} from 'react-helmet';

import Api from './../../configs/api';
import HttpUtil from './../../utils/http';

import Dashboard from './../../pages/dashboard';


class ValidationHome extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render () {
    let innerContent = (
      <div className="row">
        <div className="col-lg-3">
          <div className="card shadow mb-4">
            <a href="/validation/tithi" className="card-body">
              Tithi Validation
            </a>
          </div>
        </div>
        <div className="col-lg-3">
          <div className="card shadow mb-4">
            <a href="/validation/event" className="card-body">
              Festival Validation
            </a>
          </div>
        </div>
      </div>
    );

    let parentProps = {
      title: '',
      header: <Header />,
      content: innerContent,
      footer: <Footer />,
    };

    return (
      <Dashboard {...parentProps} />
    )
  }
}

const Header = (props) => {
  return (
    <Helmet>
      {/*Header Code Here*/}
      <title>Validation Home - Nirwanji</title>
    </Helmet>
  )
}

const Footer = (props) => {
  return (
    <div>
      {/* Footer Code Here */}
    </div>
  )
}

export default ValidationHome;
